export * from '@primeuix/themes/nora/scrollpanel';
export { default } from '@primeuix/themes/nora/scrollpanel';
